"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsedDropdownMenu = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const utils_1 = require("../../utils");
const CollapsedDropdownMenuItem_1 = require("./CollapsedDropdownMenuItem");
const DropdownSummary_1 = require("./DropdownSummary");
const Menu_styles_1 = require("./Menu.styles");
const CollapsedMenu = styled_components_1.default.div `
	visibility: ${(p) => (p.menuOpen ? "visible" : "hidden")};
	&:hover {
		visibility: visible;
	}
	background: ${(p) => p.theme.palette.background.default};
	margin: 0;
	padding: 0;
	position: absolute;
	box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);

	a {
		font-size: inherit;
		padding: 12px 16px;
		white-space: nowrap;
	}
`;
const CollapsedDropdownMenu = ({ summaryNode, links = [], menuId, locale, topOffset, }) => {
    const { open: menuOpen, setActiveMenu } = (0, shared_1.useMyActiveMenu)(menuId);
    const openMenu = (0, shared_1.useOpenMenu)(menuId);
    const closeMenu = (0, shared_1.useCloseMenu)();
    const toggleMenu = (0, shared_1.useToggleMenu)(menuOpen, setActiveMenu, menuId);
    return (react_1.default.createElement(Menu_styles_1.Menu, { role: "menu", static: true, onMouseEnter: openMenu, onMouseLeave: closeMenu },
        react_1.default.createElement(DropdownSummary_1.DropdownSummary, { menuId: menuId, openMenu: openMenu, onKeyUp: toggleMenu, disableTriangles: true }, summaryNode),
        react_1.default.createElement(CollapsedMenu, { menuOpen: menuOpen }, links.map((link, i) => {
            if (!link)
                return;
            const isEnhancedDropdown = (0, utils_1.isValidEnhancedDropdown)(link);
            const linkKey = link.key || link.title || `${i}`;
            const key = `collapsed-menu-item-${linkKey}`;
            return (react_1.default.createElement(CollapsedDropdownMenuItem_1.CollapsedDropdownMenuItem, { link: link, key: key, linkKey: linkKey, isEnhancedDropdown: isEnhancedDropdown, menuId: menuId, locale: locale, topOffset: topOffset }));
        }))));
};
exports.CollapsedDropdownMenu = CollapsedDropdownMenu;
//# sourceMappingURL=CollapsedDropdownMenu.js.map